import { Action } from 'redux';
import { getApi } from '../api/ApiProvider';
import initialState from '../initialState';
import { Category } from '../api/model';
import { NotificationActions } from './notification/notification-actions';
import { AppDispatch } from './index';
import { default as StoreModel, LoadedResource, LoadedSingleResource } from './StoreModel';


export enum CategoryActionTypes {
    FETCH_REQUEST = '[CATEGORY][LIST] Request',
    FETCH_RESPONSE = '[CATEGORY][LIST] Response',
    FETCH_ERROR = '[CATEGORY][ERROR] Error',

    SAVE_REQUEST = '[CATEGORY][SAVE] Request',
    SAVE_RESPONSE = '[CATEGORY][SAVE] Response',
    SAVE_ERROR = '[CATEGORY][SAVE] Error',

    UPLOAD_IMAGE_REQUEST = '[CATEGORY][UPLOAD_IMAGE] Request',
    UPLOAD_IMAGE_RESPONSE = '[CATEGORY][UPLOAD_IMAGE] Response',
    UPLOAD_IMAGE_ERROR = '[CATEGORY][UPLOAD_IMAGE] Error',

    DISABLE_REQUEST = '[CATEGORY][DISABLE] Request',
    DISABLE_RESPONSE = '[CATEGORY][DISABLE] Response',
    DISABLE_ERROR = '[CATEGORY][DISABLE] Error',

    MOVE_POSITION_REQUEST = '[CATEGORY][MOVE_POSITION] Request',
    MOVE_POSITION_RESPONSE = '[CATEGORY][MOVE_POSITION] Response',
    MOVE_POSITION_ERROR = '[CATEGORY][MOVE_POSITION] Error',

}

export interface ICategoryStore {
    data: LoadedResource<Category>,
    abm: LoadedSingleResource<Category>,
    disable: LoadedSingleResource<Category>,
}

export default function reductor(
    state: ICategoryStore = initialState.category,
    action: Action<CategoryActionTypes> & { payload: any }): ICategoryStore {

    if (!action) {
        return state;
    }

    switch (action.type) {
        case CategoryActionTypes.FETCH_REQUEST:
            return {
                ...state,
                data: StoreModel.fetching()
            };

        case CategoryActionTypes.FETCH_RESPONSE:
            return {
                ...state,
                data: StoreModel.result(action.payload)
            };

        case CategoryActionTypes.FETCH_ERROR:
            return {
                ...state,
                data: StoreModel.error(action.payload)
            };

        case CategoryActionTypes.SAVE_REQUEST:
            return { ...state, abm: StoreModel.fetchingSingle() };

        case CategoryActionTypes.SAVE_RESPONSE:
            return { ...state, abm: StoreModel.resultSingle(action.payload) };

        case CategoryActionTypes.SAVE_ERROR:
            return { ...state, abm: StoreModel.errorSingle(action.payload) };

        case CategoryActionTypes.DISABLE_REQUEST:
            return { ...state, disable: StoreModel.fetchingSingle() };

        case CategoryActionTypes.DISABLE_RESPONSE:

            const id = action.payload.id;
            return {
                ...state,
                disable: StoreModel.resultSingle(action.payload),
                data: {
                    ...state.data,
                    data: state.data.data.map(d => d.id === id ? action.payload : d)
                }
            };
        case CategoryActionTypes.DISABLE_ERROR:
            return { ...state, disable: StoreModel.errorSingle(action.payload) };

        case CategoryActionTypes.UPLOAD_IMAGE_REQUEST:
            return { ...state, abm: StoreModel.fetchingSingle() };

        case CategoryActionTypes.UPLOAD_IMAGE_RESPONSE:
            return { ...state, abm: StoreModel.resultSingle(action.payload) };

        case CategoryActionTypes.UPLOAD_IMAGE_ERROR:
            return { ...state, abm: StoreModel.errorSingle(action.payload) };

        case CategoryActionTypes.MOVE_POSITION_REQUEST:
            return { ...state, abm: StoreModel.fetchingSingle() };

        case CategoryActionTypes.MOVE_POSITION_RESPONSE:
            return { ...state, abm: StoreModel.resultSingle(action.payload) };

        case CategoryActionTypes.MOVE_POSITION_ERROR:
            return { ...state, abm: StoreModel.errorSingle(action.payload) };

        default:
            return state;
    }
};

export class CategoryActions {
    movePositionDown(companyId: number, categoryId: number) {
        return (dispatch: AppDispatch) => {
            const notif = new NotificationActions();

            dispatch({ type: CategoryActionTypes.MOVE_POSITION_REQUEST });

            getApi().category().move(companyId, categoryId, 'DOWN').then(response => {
                dispatch(notif.addSuccess('Categoria', 'Posición cambiada'));
                dispatch({ type: CategoryActionTypes.MOVE_POSITION_RESPONSE, payload: response });
                dispatch(this.fetch(companyId));
            }).catch(err => {
                dispatch(notif.addError('Categoria', 'Fallo al cambiar la posición'));
                dispatch({ type: CategoryActionTypes.MOVE_POSITION_ERROR, payload: err });
            })

        }
    }
    movePositionUp(companyId: number, categoryId: number) {
        return (dispatch: AppDispatch) => {
            const notif = new NotificationActions();

            dispatch({ type: CategoryActionTypes.MOVE_POSITION_REQUEST });

            getApi().category().move(companyId, categoryId, 'UP').then(response => {
                dispatch(notif.addSuccess('Categoria', 'Posición cambiada'));
                dispatch({ type: CategoryActionTypes.MOVE_POSITION_RESPONSE, payload: response });
                dispatch(this.fetch(companyId));
            }).catch(err => {
                dispatch(notif.addError('Categoria', 'Fallo al cambiar la posición'));
                dispatch({ type: CategoryActionTypes.MOVE_POSITION_ERROR, payload: err });
            })

        }
    }


    save(companyId: number, data: any) {
        return (dispatch: AppDispatch) => {
            const notif = new NotificationActions();

            dispatch({ type: CategoryActionTypes.SAVE_REQUEST });

            getApi().category().save(companyId, data).then(response => {
                dispatch(notif.addSuccess('Categoria', 'Categoria guardada'));
                dispatch({ type: CategoryActionTypes.SAVE_RESPONSE, payload: response });
                dispatch(this.fetch(companyId));
            }).catch(err => {
                dispatch(notif.addError('Categoria', 'Fallo al guardar'));
                dispatch({ type: CategoryActionTypes.SAVE_ERROR, payload: err });
            })

        }
    }

    uploadImage(companyId: number, categoryId: number, image: File) {
        return (dispatch: AppDispatch) => {
            const notif = new NotificationActions();

            dispatch({ type: CategoryActionTypes.SAVE_REQUEST });

            getApi().category().addPhoto(companyId, categoryId, image).then(response => {
                dispatch(notif.addSuccess('Categoria', 'Imagen guardada'));
                dispatch({ type: CategoryActionTypes.UPLOAD_IMAGE_RESPONSE, payload: response });
                dispatch(this.fetch(companyId));
            }).catch(err => {
                dispatch(notif.addError('Categoria', 'Fallo al guardar imagen'));
                dispatch({ type: CategoryActionTypes.UPLOAD_IMAGE_ERROR, payload: err });
            })

        }
    }

    disable(companyId: number, categoryId: number) {
        const notif = new NotificationActions();
        return (dispatch: AppDispatch) => {
            getApi().category().disable(companyId, categoryId).then((data: any) => {
                dispatch(notif.addSuccess('Categoria',
                    data.state === 'INACTIVE' ?
                        'Categoria deshabilitada' :
                        'Categoria habilitada'
                ));
                dispatch({ type: CategoryActionTypes.DISABLE_RESPONSE, payload: data });
            }).catch(err => {
                dispatch({ type: CategoryActionTypes.DISABLE_ERROR, payload: err });
            });
            return dispatch({ type: CategoryActionTypes.DISABLE_REQUEST });

        }
    }

    fetch(companyId: number) {
        return (dispatch: AppDispatch) => {
            dispatch({ type: CategoryActionTypes.FETCH_REQUEST });
            getApi().category().listAvailable(companyId).then(data => {
                dispatch({ type: CategoryActionTypes.FETCH_RESPONSE, payload: data });
            }).catch(err => {
                dispatch({ type: CategoryActionTypes.FETCH_ERROR, payload: err });
            });
        }
    }

}



// WEBPACK FOOTER //
// ./src/store/category.ts